export enum GradingSummary {
    deviant = 'deviant',
    normal = 'normal',
    unjudgable = 'unjudgable',
}
